import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// web/js/player-sync-settings/SyncSettings.tsx
//
// Collapsible "Sync Settings" panel shown above the comments area when
// more than one column is open. Contains three toggles (all on by
// default) that control cross-column playback/selection sync. Toggle
// state is persisted to localStorage and a `hekate:sync-settings-changed`
// event is dispatched on `window` whenever a toggle changes so the
// column-sync glue in html/js/player_utils.js can re-evaluate its wiring.
// The panel is rendered into the global `#player-sync-settings-container`
// DOM slot (see player.php) and is mounted/unmounted on every column-
// count change by the subscriber in html/js/player_utils.js.
import React, { useEffect, useId, useState } from 'react';
function SyncSettings({ initialExpanded = false, initialSyncPosition = true, initialAudioFollowsSelection = true, initialCommentsFollowSelection = true, }) {
    const [expanded, setExpanded] = useState(initialExpanded);
    const [syncPosition, setSyncPosition] = useState(() => getSavedSetting("player.sync.position", initialSyncPosition));
    const [audioFollows, setAudioFollows] = useState(() => getSavedSetting("player.sync.audioFollows", initialAudioFollowsSelection));
    const [commentsFollow, setCommentsFollow] = useState(() => getSavedSetting("player.sync.commentsFollow", initialCommentsFollowSelection));
    // Sync settings to localStorage and notify player_utils to re-evaluate
    useEffect(() => {
        try {
            localStorage.setItem('player.sync.position', String(syncPosition));
        }
        catch { }
        window.dispatchEvent(new Event('hekate:sync-settings-changed'));
    }, [syncPosition]);
    useEffect(() => {
        try {
            localStorage.setItem('player.sync.audioFollows', String(audioFollows));
        }
        catch { }
        window.dispatchEvent(new Event('hekate:sync-settings-changed'));
    }, [audioFollows]);
    useEffect(() => {
        try {
            localStorage.setItem('player.sync.commentsFollow', String(commentsFollow));
        }
        catch { }
        window.dispatchEvent(new Event('hekate:sync-settings-changed'));
    }, [commentsFollow]);
    const panelId = useId();
    const toggleExpanded = () => setExpanded((v) => !v);
    return (_jsxs("div", { className: "player-sync-settings", children: [_jsxs("button", { type: "button", className: "player-sync-settings-title", "aria-expanded": expanded, "aria-controls": panelId, onClick: toggleExpanded, children: [_jsx("span", { className: "mr-4", "aria-hidden": "true", children: expanded ? '▼' : '▶' }), _jsx("span", { children: "Sync Settings" })] }), expanded && (_jsxs("div", { id: panelId, className: "player-sync-settings-panel", role: "group", "aria-label": "Sync Settings", children: [_jsx("check-box", { className: "player-sync-settings-option", checked: syncPosition, text: "Sync position", onChange: (e) => setSyncPosition(e.target.checked) }), _jsx("check-box", { className: "player-sync-settings-option", checked: audioFollows, text: "Audio follows selection", onChange: (e) => setAudioFollows(e.target.checked) }), _jsx("check-box", { className: "player-sync-settings-option", checked: commentsFollow, text: "Comments follow selection", onChange: (e) => setCommentsFollow(e.target.checked) })] }))] }));
}
function getSavedSetting(key, defaultValue) {
    try {
        const val = localStorage.getItem(key);
        if (val === null)
            return defaultValue;
        return val !== 'false';
    }
    catch {
        return defaultValue;
    }
}
export default SyncSettings;
